import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Header } from '../../components/header/header';
import { Footer } from '../../components/footer/footer';
import { MetaService } from '../../core/services/meta.service';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, Header, Footer],
  template: `
    <app-header />

    <div class="min-h-screen bg-gray-50 flex items-start justify-center pt-10 pb-12 px-4 sm:px-6 lg:px-8">
      <div class="max-w-md w-full space-y-6 text-center">
        <div class="mx-auto w-24 h-24 rounded-full bg-red-100 flex items-center justify-center">
          <span class="text-4xl font-bold text-[#e8343f]">404</span>
        </div>

        <h1 class="text-2xl font-bold text-gray-900">Pagina no encontrada</h1>
        <p class="text-gray-600">
          La URL que intentas abrir no existe o fue movida.
        </p>

        <div class="flex flex-col space-y-3">
          <a
            routerLink="/"
            class="w-full py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white bg-[#e8343f] hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] transition-colors"
          >
            Volver al inicio
          </a>
          <a
            routerLink="/login"
            class="w-full py-3 px-4 border border-gray-300 text-sm font-medium rounded-lg text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e8343f] transition-colors"
          >
            Ir a iniciar sesion
          </a>
        </div>
      </div>
    </div>

    <app-footer />
  `,
  styles: []
})
export class NotFoundComponent implements OnInit {
  private metaService = inject(MetaService);

  ngOnInit(): void {
    this.metaService.resetToDefault();
  }
}
